var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRewardsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 148,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#3D3E78",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4h12v4c0 3.3-2.7 6-6 6s-6-2.7-6-6V4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H4.5A1.5 1.5 0 0 1 3 4.5V4a1 1 0 0 1 1-1h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6h1.5a1.5 1.5 0 0 0 1.5-1.5V4a1 1 0 0 0-1-1h-2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14v5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19h6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21h10"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsLogo);
export default __webpack_public_path__ + "static/media/RewardsLogo.5a4fe25773814039f0f32088bc320cbd.svg";
export { ForwardRef as ReactComponent };